import React, { Fragment, memo, useState } from 'react';
import { ButtonThemes } from '../../libraries/ButtonTheme';
import Button from '../button/Button';
import CalendarEvent, {
  CalendarEventProps,
} from '../calendarEvent/CalendarEvent';
import Col from '../col/Col';
import Collapse from '../collapse/Collapse';
import ScrollArrowOverflow from '../scrollArrowOverflow/ScrollArrowOverflow';
import './HourEvents.scss';
const rootClassName = 'hour-events';

export interface HourEventsProps {
  hour: string;
  events?: CalendarEventProps[];
  eventCols?: (1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12)[];
  arrows?: 'bottom' | 'left' | 'right';
  defaultOpened?: boolean;
  language?: {
    label: {
      opened: string;
      closed: string;
    };
    noEvent: string;
    events: (n: number) => string;
  };
}

function HourEvents(props: HourEventsProps) {
  const [opened, setOpened] = useState(props.defaultOpened);
  return (
    <div className={rootClassName}>
      <div className={`${rootClassName}-first-line`}>
        <div className={`${rootClassName}-hour`}>{props.hour}</div>
        <div className={`${rootClassName}-line`} />
        {!props.events || !props.events.length ? (
          <div className={`${rootClassName}-no-events nunito`}>
            {props.language?.noEvent}
          </div>
        ) : (
          <div className={`${rootClassName}-counter nunito`}>
            {props.language?.events(props.events?.length)}
          </div>
        )}
      </div>
      {props.events?.length ? (
        <Fragment>
          <div className={`${rootClassName}-toggle`}>
            <Button
              theme={ButtonThemes.DefaultPrimary}
              onClick={() => {
                setOpened(!opened);
              }}
            >
              {props.language?.label[opened ? 'opened' : 'closed']}
            </Button>
          </div>
          <Collapse opened={opened} animateOpacity>
            <ScrollArrowOverflow arrows={props.arrows}>
              {props.events?.map((e, index) => {
                return (
                  <Col cols={props.eventCols} key={e.id || index}>
                    <CalendarEvent {...e} />
                  </Col>
                );
              })}
            </ScrollArrowOverflow>
          </Collapse>
        </Fragment>
      ) : undefined}
    </div>
  );
}

HourEvents.defaultProps = {
  eventCols: [6, 6, 5, 3, 3],
  events: [],
  defaultOpened: true,
  language: {
    events: (n: number) => `${n} evento${n !== 1 ? 's' : ''}`,
    label: {
      opened: 'Ver menos',
      closed: 'Ver mais',
    },
    noEvent: 'Nenhum evento',
  },
} as Partial<HourEventsProps>;

export default memo(HourEvents);
